<mat-dialog-content>
	<div
		[formGroup]="group"
		class="searchWrapper mt-2 flex flex-shrink-0 flex-col justify-stretch"
	>
		<div class="searchInput flex flex-col items-start justify-center px-2">
			<mat-form-field
				appearance="fill"
				class="project-template-dialog-search mat-form-field-compact mat-form-field-no-hint w-full"
			>
				<input
					cdkFocusInitial
					formControlName="search"
					ignoreAutocomplete
					matInput
					tabindex="0"
					type="text"
				>
				<mat-icon matSuffix>search</mat-icon>
			</mat-form-field>
		</div>
		@if (templatesEmpty$ | async) {
		<p class="project-template-dialog-empty mat-caption px-4 py-6 text-center">
			{{ 'project.template.none' | translate }}
		</p>
		} @else { @if (searchNoResults$ | async) {
		<p
			class="project-template-dialog-empty mat-caption flex min-h-[380px] items-center justify-center px-4 text-center"
		>
			{{ 'project.template.searchNoResults' | translate }}
		</p>
		} @else {
		<cdk-virtual-scroll-viewport
			[maxBufferPx]="800"
			[minBufferPx]="300"
			[style.height.px]="380"
			itemSize="40"
		>
			<mat-list
				class="pb-8"
				dense
				role="listbox"
			>
				<ng-container *cdkVirtualFor="let entry of data$filtered | async; trackBy: trackId">
					<ng-container *ngTemplateOutlet="projectItem; context: { $implicit: entry }"></ng-container>
				</ng-container>
			</mat-list>
		</cdk-virtual-scroll-viewport>
		} }
	</div>
</mat-dialog-content>
<ng-template
	#clientItem
	let-entry
>
	<h3 matSubheader>
		<span class="--client-title">{{
			entry.id === 'internal' ? (entry.name | translate) : (entry | defaultEntityTranslate: 'client' : 'client.none')
		}}</span>
	</h3>
</ng-template>
<ng-template
	#projectItem
	let-project
>
	<mat-list-item
		(click)="setProject(project)"
		class="h-10 cursor-pointer truncate"
		matRippleDisabled
		tabindex="0"
	>
		<div class="flex items-center space-x-2 truncate">
			<div [ngClass]="{ radio: true, active: project.selected }"></div>
			<span class="truncate leading-none">
				{{ project | defaultEntityTranslate: 'project' : 'project.none' }}</span
			>
		</div>
	</mat-list-item>
</ng-template>
